// Content Platform — static-page content registry. The single place where authored marketing pages
// (About, Fleet, Corporate, Recruitment, Partner, Sustainability, Legal/Campaign landing, …) declare
// their content blocks, keyed by the page's seoData `seoKey`. Services are NOT here — they are
// catalogue-driven (content/services/). EMPTY today: pages are added in the content-authoring phase.
//
// Pure data, node-importable (validated build-time). GOVERNANCE: presentation data only — no facts/
// identity (those live in sabProfile / companyLegalIdentity). Adding a page is content + one route
// line; never a bespoke React page component (see <ContentRoute>).

import about from './about.js';

export const PAGE_CONTENT = Object.freeze({
  // [seoKey]: { blocks: [ { type: 'hero', title: '…' }, … ] }
  about, // Phase 3 — first production content page
});

/**
 * Resolve a static page's block list by seoKey.
 * @param {string} seoKey
 * @returns {Array|null} blocks, or null if the page is not registered (fail-closed)
 */
export function getPageContent(seoKey) {
  const page = PAGE_CONTENT[seoKey];
  return page && Array.isArray(page.blocks) && page.blocks.length ? page.blocks : null;
}
